export const GET_HISTORY_TRANSACTION_REQUEST = 'instalent/GET_HISTORY_TRANSACTION_REQUEST';
export const GET_HISTORY_TRANSACTION_SUCCESS = 'instalent/GET_HISTORY_TRANSACTION_SUCCESS';
export const GET_HISTORY_TRANSACTION_FAIL = 'instalent/GET_HISTORY_TRANSACTION_FAIL';
